<template>
  <div>
    <div class="search-wrap">
      <el-button size="mini" @click="search()" style="margin-right: 5px;">查询</el-button>
      <el-button size="mini" @click="moneySplit()" style="margin-right: 5px;">按金额拆分</el-button>
      <el-button size="mini" @click="split()" style="margin-right: 5px;">账单拆分</el-button>
      <el-button size="mini" @click="rollback()" style="margin-right: 5px;">拆分恢复</el-button>
      <div style="width: 30px;display: inline-block;"></div>
      <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
         <el-descriptions-item label="房产信息">
            <!-- <el-input size="mini" style="width: 100%;" placeholder="请输入房产" v-model="where.house_name" clearable></el-input> -->
            <el-autocomplete
              v-model="where.house_name"
              size="mini"
              style="width: 100%;"
              :fetch-suggestions="querySearchAsync"
              placeholder="可搜索房产"
              clearable
              @select="handleSelect"
            ></el-autocomplete>
          </el-descriptions-item>
          <el-descriptions-item  label="收费项目">
            <div>
              <el-select v-model="where.chargeitemID" multiple filterable collapse-tags style="width: 80%" placeholder="收费项目">
                <el-option size="mini" v-for="item in chargeitem" :key="item.id" :label="item.chargeItem_name" :value="item.id"></el-option>
              </el-select>
              <span style="cursor: pointer" @click="complete">全选</span>
              <span style="margin-left: 3px; cursor: pointer" @click="cancel">取消</span>
            </div>
          </el-descriptions-item>
          <el-descriptions-item  label="计费周期">
            <el-date-picker v-model="where.startDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
            <span style="margin-left: 1px;margin-right: 1px;">至</span>
            <el-date-picker v-model="where.endDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item  label="拆分日期">
            <el-date-picker v-model="where.HsplitStartDate" type="datetime" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
            <span style="margin-left: 1px;margin-right: 1px;">至</span>
            <el-date-picker v-model="where.HsplitEndDate" type="datetime" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item  label="账单状态">
            <RadioGroup v-model="where.money">
                <Radio label="待付款"></Radio>
                <Radio label="部分缴款" disabled ></Radio>
                <Radio label="已结清" disabled ></Radio>
            </RadioGroup>
          </el-descriptions-item>
          <el-descriptions-item  label="">

          </el-descriptions-item>
      </el-descriptions>
    </div>
    <div style="margin-top: 5px;">
      <el-table style="width: 100%" height="50vh" v-if="pageData" v-loading="loading" border :data="list" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column prop="h_name_date" label="房产" width="300"></el-table-column>
        <el-table-column prop="chargeItem_name" label="收费项目" width="150"></el-table-column>
        <el-table-column prop="str_end" label="计费周期" align="center" width="150"></el-table-column>
        <el-table-column prop="xsc_Price" label="单价" align="center" width="100"></el-table-column>
        <el-table-column prop="xsc_Amount" label="数量" align="center" width="100"></el-table-column>
        <el-table-column prop="charge" label="实际应收" align="center" width="100"></el-table-column>
        <el-table-column prop="PaidChargeSum" label="已缴金额" align="center" width="100"></el-table-column>
        <el-table-column prop="split_name" label="拆分人" align="center" width="100"></el-table-column>
        <el-table-column prop="split_date" label="拆分时间" align="center" width="150"></el-table-column>
        <el-table-column prop="remark" label="备注" width="300"></el-table-column>
      </el-table>
    </div>
    <div class="pagination-wrap">
      <el-pagination background layout="total,prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
    </div>
    <el-dialog title="拆分" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">
      <div style="overflow-y: auto;">
        <el-button size="mini" @click="split_update()" style="margin-bottom: 5px;">确定拆分</el-button>
        <div style="color: red;">拆分的计费周期，只拆分计费周期相同的开始日期和结束日期的账单（开始日期-结束日期）,按月拆分，计费周期不能大于一个月</div>
        <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item  label="计费周期">
              <el-date-picker v-model="where.splitStartDate" type="date" size="mini" style="width: 47%;" placeholder="开始日期"></el-date-picker>
              <span style="margin-left: 1px;margin-right: 1px;">-</span>
              <el-date-picker v-model="where.splitEndDate" type="date" size="mini" style="width: 47%;" placeholder="结束日期"></el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item  label="拆分日期">
              <el-date-picker v-model="where.splitDate" type="date" size="mini" style="width: 47%;" placeholder="拆分日期"></el-date-picker>
            </el-descriptions-item>
        </el-descriptions>
        <div style="width: 100%;height: 200px;"></div>
      </div>
    </el-dialog>

    <el-dialog title="按金额拆分" :visible.sync="dialogVisible1" :close-on-click-modal="false" width="1000px">
      <div style="overflow-y: auto;">
        <el-button size="mini" @click="split_update_money()" style="margin-bottom: 5px;">确定拆分</el-button>
        <div style="color: red;">按金额拆分账单，不拆分周期，备注必须填写</div>
        <el-descriptions :column="2" border size="mini" style="margin-top: 10px;" :labelStyle="{width: '123px'}" :contentStyle="{width:'42%'}">
            <el-descriptions-item  label="拆分类型">
              <RadioGroup v-model="select.type">
                  <Radio label="按金额拆分"></Radio>
                  <Radio label="按百分比拆分"></Radio>
              </RadioGroup>
            </el-descriptions-item>
            <el-descriptions-item v-if="select.type == '按金额拆分'"  label="拆分金额">
              <el-input size="mini" v-model="select.money" ></el-input>
            </el-descriptions-item>
            <el-descriptions-item v-if="select.type == '按百分比拆分'"  label="拆分比率">
              <el-input size="mini" v-model="select.money" ></el-input>
            </el-descriptions-item>
            <el-descriptions-item  label="备注">
              <el-input size="mini" v-model="select.remark" placeholder="备注"></el-input>
            </el-descriptions-item>
        </el-descriptions>
        <div style="width: 100%;height: 200px;"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "OrderLog",
  data(){
    return{
      select:{
        type:'按百分比拆分',
        money:'',
        remark:''
      },
      selectList:[],
      loading: false,
      dialogVisible:false,
      dialogVisible1:false,
      where:{
        name:"",
        house_name:"",
        start_end_time:"",
        use_name:"",
        startDate:"",
        endDate:"",
        splitStartDate:"",
        splitEndDate:"",
        splitDate:"",
        chargeitemID:"",
        money:"待付款",
        HsplitStartDate:'',
        HsplitEndDate:''
      },
      chargeitem:[],
      list:[],
      pageData:{
        total:0,
        pageSize:15,
        page:1
      },
      multipleSelection:[],
      order_bill_type_list:[],
      house_charge_item_list:[],
      house_charge_list:[],

      info_keys:[],
      info_obj:{}
    }
  },
  watch:{
    info_obj:{
      deep:true,
      immediate:true,
      handler(n){
        this.info_keys=Object.keys(n);
      }
    }
  },
  methods:{
    //按金额拆分
    moneySplit(){
      this.dialogVisible1 = true;
      // this.$Message.success("开发中");
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      let data = {'data':this.where,'pageData':this.pageData}
      this.$myhttp.post('admin/OrderSplit/index',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data.code == 201){
            this.$Message.error(backdata.data.message);
          }else{
            this.pageData.total = backdata.data.count;
            this.list = backdata.data.data;
            this.$Message.success(backdata.data.message);
          }
      },err=>{
        this.$Message.error('请求超时!');
      });
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    handleSelectionChange(val) {
      //console.log(val)
      this.multipleSelection = val;
    },
    //拆分
    split(){
      this.dialogVisible = true;
    },
    split_update(){
     this.$confirm('确定拆分', '提示', {
       confirmButtonText: '确定',
       cancelButtonText: '取消',
       type: 'warning'
     }).then(() => {
      ERP.showLoading()
      this.dialogVisible = false;
      let data = {'data':this.where,'pageData':this.pageData,'multipleSelection':this.multipleSelection}
      this.$myhttp.post('admin/OrderSplit/split_update',data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          ERP.hideLoading()
          if(backdata.data.code != 200){
            this.$confirm(''+backdata.data.message, '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {

            }).catch(() => {

            });
          }else{
            this.getList();
            this.$Message.success(backdata.data.message);
          }
      },err=>{
        ERP.hideLoading()
        this.$Message.error('请求超时!');
      });
     }).catch(() => {

     });
    },
    split_update_money(){
      this.$confirm('确定拆分', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
       ERP.showLoading()
       this.dialogVisible = false;
       let data = {'data':this.where,'pageData':this.pageData,'select':this.select,'multipleSelection':this.multipleSelection}
       this.$myhttp.post('admin/OrderSplit/split_update_money',data,{
         'Content-Type': 'application/x-www-form-urlencoded'
         }).then(backdata=>{ // 异步执行成功后
           ERP.hideLoading()
           if(backdata.data.code != 200){
             this.$confirm(''+backdata.data.message, '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
             }).then(() => {

             }).catch(() => {

             });
           }else{
             this.getList();
             this.$Message.success(backdata.data.message);
           }
       },err=>{
         ERP.hideLoading()
         this.$Message.error('请求超时!');
       });
      }).catch(() => {

      });
    },
    nodeClick(data){
      this.where.house_name=data.tree.map(ret => {
        return ret.name
      }).join('->');
      //加载收费大类（费项）
      this.$myhttp.get("admin/common/getChargeitem", {
          "Content-Type": "application/json",
      }).then((backdata) => {
        this.chargeitem = backdata.data.data;
      });
      this.$forceUpdate();
      this.getList();
    },
    //全选
    complete() {
      let data = this.chargeitem;
      let id = data
        .map((ret) => {
          return ret.id;
        })
        .join(",");
      let idarray = "[" + id + "]";
      this.where.chargeitemID = JSON.parse(idarray);
    },
    //取消
    cancel() {
      this.where.chargeitemID = [];
    },

    //远程搜索方式
    querySearchAsync(query, cb) {
      if (query !== '') {
        this.$myhttp.get('admin/common/house_name?house_name='+query,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.selectList = backdata.data.data;
            let value = [];
            this.selectList.map(req=>{
              value.push({'value':req.house})
            })
            cb(value)
        });
      }
    },
    //搜索选中
    handleSelect(item) {
      this.where.house_name = item.value;
    },

    rollback(data=null){
      var that=this;
      this.$confirm('是否确定恢复数据继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERP.showLoading()
        let data = {'data':this.where,'pageData':this.pageData,'multipleSelection':this.multipleSelection}
        this.$myhttp.post('admin/OrderSplit/rollback',data,{
          'Content-Type': 'application/x-www-form-urlencoded'
          }).then(backdata=>{ // 异步执行成功后
            ERP.hideLoading()
            if(backdata.data.code != 200){
              this.$confirm(''+backdata.data.message, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {

              }).catch(() => {

              });
            }else{
              this.getList();
              this.$Message.success(backdata.data.message);
            }
        },err=>{
          ERP.hideLoading()
          this.$Message.error('请求超时!');
        });
      }).catch(() => {

      });
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.table-wrap {
  margin-top: 5px;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}


.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 450px );
  //overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/OrderSplit.vue